import React, { useEffect, useState } from 'react'
import { useGetCompletedTrainings } from '../../redux/employee/hook/training'
import { PAGINATION_DEFAULT } from '../../utils/constants'
import DataTable from '../../components/datatable'

const CompletedTraining = () => {
  useEffect(() => {
    window.scroll(0, 0)
  }, [])

  const [tableType, setTableType] = useState('completed_training')

  const switchFunction = () => {
    if (tableType === 'completed_training') {
      setTableType('table')
    } else {
      setTableType('completed_training')
    }
  }

  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    search: '',
  })
  const { data: trainings } = useGetCompletedTrainings(
    pagination?.limit,
    pagination?.page,
    pagination?.search
  )

  const tableConfig = {
    headers: [
      'Training Name',
      'Training Period',
      'Passing Grade',
      'Training Score',
    ],
    keys: [
      'module_name',
      'period',
      'passing_grade_percentage',
      'score',
    ],
    mobileHeader: {
      left: {
        title: 'Training',
        key: 'module_name',
      },
      right: {
        title: 'Period',
        key: 'period',
      },
    },
  }

  return (
    <div className='flex flex-col bg-white shadow-md rounded'>
      <DataTable
        data={trainings}
        tableConfig={tableConfig}
        updatePagination={(data) => setPagination(data)}
        computedActions={true}
        tableType={tableType}
        switchFunction={switchFunction}
        layoutSwitch={true}
        searchData={true}
        noCheck={true}
      />
    </div>
  )
}

export default CompletedTraining
